import { Injectable } from '@angular/core'
import { ICandidateApplicationUpdateStage } from '@candidate/app/models/candidate-job-update.model'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { COLLECTIONS } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class ApplicationUpdateStageRepository extends CollectionRepository<ICandidateApplicationUpdateStage> {
  COLLECTION = COLLECTIONS.CANDIDATE_APPLICATION_UPDATE_STAGE
}
